import React from 'react';
import {observer} from 'mobx-react';
import {t} from 'shared/core';

const OvertimeCell = observer(({model}) => {
  return (
    <div>
      <div>{model.overtime}</div>
      {!!parseFloat(model.overtimeLieuTime) &&
        <div className='h6'>{t('time_tracking.payroll_hours.LIEU_TIME_EARNED', {lieuTime: model.overtimeLieuTime})}</div>}
    </div>
  );
});

export default OvertimeCell;
